import { MARIGOLD_LIGHT, MARIGOLD_MEDIUM } from 'HubStyleTokens/colors';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { jsx as _jsx } from "react/jsx-runtime";
const Banner = styled.div.withConfig({
  displayName: "ConditionWarningBanner__Banner",
  componentId: "sc-14pnefr-0"
})(["background-color:", ";border:1px solid ", ";line-height:18px;margin:3px 50px 4px 0;padding:1px 5px;"], MARIGOLD_LIGHT, MARIGOLD_MEDIUM);
const ConditionWarningBanner = ({
  className,
  children
}) => {
  return /*#__PURE__*/_jsx(Banner, {
    className: className,
    children: children
  });
};
ConditionWarningBanner.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string
};
export default ConditionWarningBanner;